<template>
    <div class="row detail_row">
        <div class="col col-6 detail_row_header">
            <slot name="header"></slot>
        </div>
        <div class="col col-6">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "payment-details-row",
};
</script>

<style lang="scss">
@use "@/scss/custom";

.detail_row {
    &:not(:last-of-type) {
        margin-bottom: 6px;
    }
}

.detail_row_header {
    color: custom.$dark;
}
</style>
